import { BroadcastIcon, FileVideoIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Badge, BadgeVariant } from '../Badge';

interface SourceTypeBadgeProps {
    type: 'camera' | 'file';
}

const badgeConfig: Record<
    'camera' | 'file',
    { icon: typeof BroadcastIcon; textKey: string; variant: BadgeVariant }
> = {
    camera: {
        icon: BroadcastIcon,
        textKey: 'badge.live',
        variant: 'positive-glass',
    },
    file: {
        icon: FileVideoIcon,
        textKey: 'badge.uploadedFile',
        variant: 'neutral-glass',
    },
};

export function SourceTypeBadge({ type }: SourceTypeBadgeProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    const { icon: Icon, textKey, variant } = badgeConfig[type];

    return (
        <Badge variant={variant}>
            <Icon size={16} weight="fill" className="flex-shrink-0" />
            <span className="text-xs-medium">{t(textKey)}</span>
        </Badge>
    );
}
